import { render, staticRenderFns } from "./UserLogoImage.vue?vue&type=template&id=b92a0954&scoped=true"
import script from "./UserLogoImage.vue?vue&type=script&lang=js"
export * from "./UserLogoImage.vue?vue&type=script&lang=js"
import style0 from "./UserLogoImage.vue?vue&type=style&index=0&id=b92a0954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92a0954",
  null
  
)

export default component.exports